import Link from 'next/link';
import { getContrast } from 'polished';
import { Divider } from '@/components/shared/Divider';
import type { BrokerContact as BrokerContactType } from '@/graphql/common/types';
import { ArrowRightIcon } from '@/icons';
import colors from '@/theme/colors';
import { formatPhoneNumber } from '@/utils/formatPhoneNumber';
import { onlyNumbers } from '@/utils/onlyNumbers';
import { getFullAddress } from '../../../utils/getFullAdress';

type BrokerListItemProps = BrokerContactType;

export const BrokerListItem = ({
  name,
  address,
  email,
  phone,
  website,
  benefit
}: BrokerListItemProps) => (
  <div className="flex flex-col gap-2 bg-grey-100 p-4 shadow-[inset_0px_-1px_0px_0px] shadow-grey-200">
    <div className="flex items-center gap-1">
      <h6 className="line-clamp-1 text-sm font-semibold uppercase leading-[1.125rem] tracking-[1px] text-blue-400">
        {name}
      </h6>
      <div className="flex flex-row items-center gap-4">
        {benefit?.title && (
          <span
            className="rounded-full px-2 py-1 text-xs font-semibold uppercase tracking-[1px]"
            style={{
              backgroundColor: benefit.color?.hex ?? colors.white,
              color:
                getContrast(benefit.color?.hex ?? colors.white, colors.white) > 3.5
                  ? colors.white
                  : colors.grey[900]
            }}
          >
            {benefit.title}
          </span>
        )}
        {benefit?.title && website && (
          <Divider orientation="vertical" className="h-3 border-grey-300" />
        )}
        {website ? (
          <Link
            href={website}
            target="_blank"
            prefetch={false}
            className="flex size-4 items-center justify-center text-blue-400 transition-colors hover:text-blue-500"
          >
            <ArrowRightIcon aria-hidden className="-rotate-45" />
          </Link>
        ) : (
          <span className="flex size-4 items-center justify-center text-grey-400">
            <ArrowRightIcon aria-hidden className="-rotate-45" />
          </span>
        )}
      </div>
    </div>

    <div className="flex flex-col gap-1">
      <p className="text-xs font-regular text-grey-700">{getFullAddress(address)}</p>
      {(email || phone) && (
        <div className="flex flex-row gap-1">
          {email && (
            <a
              href={`mailto:${email}`}
              className="text-xs font-regular text-grey-700 hover:underline"
            >
              {email}
            </a>
          )}
          {email && phone && phone.length > 0 && (
            <Divider orientation="vertical" className="h-3 border-grey-300" />
          )}
          {phone && phone.length > 0 && (
            <a
              href={`tel:+55${onlyNumbers(phone[0].number)}`}
              className="text-xs font-regular text-grey-700 hover:underline"
            >
              {formatPhoneNumber(phone[0].number)}
            </a>
          )}
        </div>
      )}
    </div>
  </div>
);
